import { render, staticRenderFns } from "./BlockPreview.vue?vue&type=template&id=797c6778&"
import script from "./BlockPreview.vue?vue&type=script&lang=js&"
export * from "./BlockPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports